(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("skeletos-web-router", [], factory);
	else if(typeof exports === 'object')
		exports["skeletos-web-router"] = factory();
	else
		root["skeletos-web-router"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition